(function () {
  function scrollToReviews(behavior) {
    var target = document.querySelector('#reson-customer-reviews');
    if (!target) return;
    var offset = window.matchMedia('(max-width: 768px)').matches ? 80 : 110;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: behavior
    });
  }

  function stabilizeReviewPosition(initialBehavior) {
    scrollToReviews(initialBehavior || 'auto');

    var observer;
    var timer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          if (window.location.hash === '#reson-customer-reviews') {
            scrollToReviews('auto');
          }
        }, 80);
      });
      observer.observe(document.body);
      window.setTimeout(function () { observer.disconnect(); }, 20000);
    }

    [600, 1800, 3600, 6000, 9000, 12000, 15000, 18000].forEach(function (delay) {
      window.setTimeout(function () { scrollToReviews(delay === 600 ? 'smooth' : 'auto'); }, delay);
    });
  }

  document.addEventListener('click', function (event) {
    var clicked = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = clicked && clicked.closest('a.reson-product-rating');
    if (!link || !document.querySelector('#reson-customer-reviews')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.location.hash !== '#reson-customer-reviews') {
      window.history.pushState(null, '', '#reson-customer-reviews');
    }
    stabilizeReviewPosition('smooth');
  }, true);

  window.addEventListener('load', function () {
    if (window.location.hash === '#reson-customer-reviews') {
      stabilizeReviewPosition('auto');
    }
  });
})();
